<script setup lang="ts">
defineProps<{ count: number }>();
</script>

<template>
  <div
    class="min-w-4 h-4 border px-[1px] flex items-center justify-center font-light text-sm"
  >
    {{ count }}
  </div>
</template>
